<template>
    <Modal
        v-if="showModal"
        :allowClose="true"
        @modal:close="closeModal"
        :maxWidth="'max-w-[270px]'"
    >
        <template #body>
           <div>
               <h3
                   class="text-won-blue font-bold text-center text-[20px] leading-[24px]"
               >
                   Margin Setup
               </h3>
               
               <div class="max-w-28 mx-auto flex flex-col gap-3 mt-11">
                   <div class="grid grid-cols-2 items-center">
                       <span
                           class="text-left font-medium text-[14px] leading-[17px] text-won-dark-gray"
                       >
                           Top
                       </span>
                       <TextInput 
                           v-model="marginTop"
                           :marginTop="false"
                           :showErrors="false"
                       />
                   </div>

                   <div class="grid grid-cols-2 items-center">
                       <span
                           class="text-left font-medium text-[14px] leading-[17px] text-won-dark-gray"
                       >
                           Bottom
                       </span>
                       <TextInput
                           v-model="marginBottom"
                           :marginTop="false"
                           :showErrors="false"
                       />
                   </div>

                   <div class="grid grid-cols-2 items-center">
                       <span
                           class="text-left font-medium text-[14px] leading-[17px] text-won-dark-gray"
                       >
                           Left
                       </span>
                       <TextInput
                           v-model="marginLeft"
                           :marginTop="false"
                           :showErrors="false"
                       />
                   </div>

                   <div class="grid grid-cols-2 items-center">
                       <span
                           class="text-left font-medium text-[14px] leading-[17px] text-won-dark-gray"
                       >
                           Right
                       </span>
                       <TextInput
                           v-model="marginRight"
                           :marginTop="false"
                           :showErrors="false"
                       />
                   </div>
               </div>
           </div>
        </template>

        <template #actions>
            <div class="flex gap-3 w-full">
                <button class="py-2 text-won-dark border border-[#C2C4C6] rounded w-full"
                        v-on:click="closeModal">
                    Cancel
                </button>
    
                <button
                    class="py-2 text-white bg-won-green rounded disabled:bg-won-gray hover:opacity-90 w-full"
                    v-on:click="saveMarginsHandler"
                >
                    OK
                </button>
            </div>
        </template>
    </Modal>
</template>

<script setup>
import {ref, toRefs, watch} from "vue";
import { storeToRefs } from "pinia";
import { useBuilderStyles } from "../../store/builder-style.store";
import { useBuilder } from "../../store/builder.store";

import TextInput from "../../forms/elements/text.vue";
import Modal from "../../components/modal.vue";

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    closeModal: {
        type: Function,
        default: () => {}
    }
})

const { closeModal } = toRefs(props);

const builderStore = useBuilder();
const { data } = storeToRefs(builderStore);

const builderStylesStore = useBuilderStyles();

const marginTop = ref(36);
const marginBottom = ref(36);
const marginLeft = ref(60);
const marginRight = ref(60);

watch(data, (newVal) => {
    if(newVal == null) {
        return;
    }
    
    const { top_margin, bottom_margin, left_margin, right_margin } = newVal.options;
    
    marginTop.value = top_margin || 36;
    marginBottom.value = bottom_margin || 36;
    marginLeft.value = left_margin;
    marginRight.value = right_margin;
})

const saveMarginsHandler = () => {
    const margins = {
        top: marginTop.value,
        bottom: marginBottom.value,
        left: marginLeft.value,
        right: marginRight.value,
    }
    
    builderStylesStore.updateMargins(margins);

    closeModal.value();
}
</script>

